import { sdkFactory as wixEcommerceCouponsV2Coupon_sdkFactory_coupons } from './src/ecommerce-coupons-v2-coupon.frontend';
import { sdkFactory as wixMarketingMarketingConsentV1MarketingConsent_sdkFactory_marketingConsent } from './src/marketing-marketing-consent-v1-marketing-consent.frontend';
import { sdkFactory as wixPromoteMarketingV2AdsTxt_sdkFactory_adsTxt } from './src/promote-marketing-v2-ads-txt.frontend';
export function sdkFactory(args) {
    return {
        coupons: wixEcommerceCouponsV2Coupon_sdkFactory_coupons(args),
        marketingConsent: wixMarketingMarketingConsentV1MarketingConsent_sdkFactory_marketingConsent(args),
        adsTxt: wixPromoteMarketingV2AdsTxt_sdkFactory_adsTxt(args),
    };
}
//# sourceMappingURL=index.frontend.js.map